import { styled } from 'baseui'

export const EnvironmentBannerBar = styled('div', ({ $theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '24px',
  backgroundColor: $theme.colors.bgPulseEnvBanner,
  color: $theme.colors.textPulseStrong,
  fontSize: '12px',
  fontWeight: 600,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
}))
